"use client";

import Image from "next/image";
import { StepsDisplay, jagdpachtSteps } from "@/components/landing/StepsDisplay";
import { Check } from "lucide-react";
import { ButtonLink } from "@/components/ui";

export function JagdpachtenSection() {
  return (
    <section id="jagdpachten" className="section-lg px-4 bg-zinc-50">
      <div className="container-wide">
        {/* Section Header */}
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-primary mb-3">Jagdpachten</h2>
          <p className="text-zinc-600 max-w-2xl mx-auto">
            Sie möchten Ihr Revier zur Jagdpacht anbieten oder sind als Jäger auf der Suche nach
            einem geeigneten Revier? Inserieren Sie kostenfrei und unkompliziert auf unserer
            Plattform
          </p>
        </div>

        {/* Steps */}
        <div className="mb-12">
          <StepsDisplay steps={jagdpachtSteps} />
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-2 gap-8">
          {/* Find Hunting Ground Card */}
          <div className="bg-white rounded-xl overflow-hidden">
            <div className="relative h-48 md:h-56">
              <Image
                src="/content/heroes/jagdrevier-finden.webp"
                alt="Jagdrevier finden"
                fill
                className="object-cover"
              />
            </div>
            <div className="p-6">
              <h3 className="text-xl font-bold text-primary mb-3">Jagdrevier finden</h3>
              <p className="text-zinc-600 text-sm mb-4">
                Das Pachten eines Jagdreviers ist eine gute Möglichkeit, die Jagdleidenschaft
                auszuleben und gleichzeitig einen Beitrag zur Hege und Pflege der Natur zu leisten.
                Bevor Sie sich jedoch auf diese verantwortungsvolle Aufgabe einlassen, ist es
                wichtig, sich umfassend über die damit verbundenen rechtlichen, ökologischen und
                finanziellen Aspekte zu informieren.
              </p>
              <div className="flex flex-wrap gap-3">
                <ButtonLink href={"/jagd"} variant="secondary">
                  Jagdrevier finden
                </ButtonLink>
                <ButtonLink href={"/jagd"} variant="outline">
                  Mehr erfahren
                </ButtonLink>
              </div>
            </div>
          </div>

          {/* Lease Land Card */}
          <div className="bg-white rounded-xl overflow-hidden">
            <div className="relative h-48 md:h-56">
              <Image
                src="/content/heroes/jagdpacht-flaechen.webp"
                alt="Land- und forstwirtschaftliche Flächen verpachten"
                fill
                className="object-cover"
              />
            </div>
            <div className="p-6">
              <h3 className="text-xl font-bold text-primary mb-3">
                Land- und forstwirtschaftliche Flächen verpachten
              </h3>
              <p className="text-zinc-600 text-sm mb-4">
                Neben der klassischen Verpachtung zur land- oder forstwirtschaftlichen Nutzung von
                Flächen, stellen Jagdpachten von Acker- oder Waldflächen eine wirtschaftliche
                Nutzung dar, die zudem dem Erhalt und der Pflege dienen. Erfahren Sie bei uns mehr
                über dieses interessante Thema.
              </p>
              <div className="space-y-2 mb-4">
                <div className="flex items-center gap-2 text-sm text-zinc-700">
                  <Check className="w-4 h-4 text-accent" />
                  <span>Jährliche Pachteinnahmen sichern</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-zinc-700">
                  <Check className="w-4 h-4 text-accent" />
                  <span>Anforderungen der jeweiligen Jagdbehörden erfüllen</span>
                </div>
              </div>
              <div className="flex flex-wrap gap-3">
                <ButtonLink href={"/jagd"} variant="secondary">
                  Fläche anbieten
                </ButtonLink>
                <ButtonLink href={"/jagd"} variant="outline">
                  Mehr erfahren
                </ButtonLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
